import { Medication } from '../../generated';

export enum MedicationStoreActionTypes {
  GET_MEDICATION_SUCCESS = 'GET_MEDICATION_SUCCESS',
  FETCH_MEDICATION_NOTES_SUCCESS = 'FETCH_MEDICATION_NOTES_SUCCESS',
  SET_MEDICATION_NOTES_LOADING = 'SET_MEDICATION_NOTES_LOADING',
  ADD_MEDICATION_NOTE_SUCCESS = 'ADD_MEDICATION_NOTE_SUCCESS',
  UPDATE_MEDICATION_NOTE_SUCCESS = 'UPDATE_MEDICATION_NOTE_SUCCESS',
  DELETE_MEDICATION_NOTE_SUCCESS = 'DELETE_MEDICATION_NOTE_SUCCESS',
  SET_MEDICATION_NOTE_ACTION_STATUS = 'SET_MEDICATION_NOTE_ACTION_STATUS',
  CLEAR_MEDICATION_NOTE_ACTION_STATUS = 'CLEAR_MEDICATION_NOTE_ACTION_STATUS',
  FETCH_MEDICATION_STATUS_HISTORY_SUCCESS = 'FETCH_MEDICATION_STATUS_HISTORY_SUCCESS',
  SET_MEDICATION_STATUS_HISTORY_LOADING = 'SET_MEDICATION_STATUS_HISTORY_LOADING',
  SET_UPDATE_MEDICATION_STATUS_SUCCESS = 'SET_UPDATE_MEDICATION_STATUS_SUCCESS',
  RESET_UPDATE_MEDICATION_STATUS_SUCCESS = 'RESET_UPDATE_MEDICATION_STATUS_SUCCESS',
}

export type GetMedicationSuccessAction = {
  type: MedicationStoreActionTypes.GET_MEDICATION_SUCCESS;
  payload: Array<Medication>;
};

export interface MedicationNote {
  note_id: number;
  created_by: string;
  body: string;
  created_at: string;
}

export interface NoteActionStatus {
  success: boolean;
  message: string;
  show: boolean;
}

export type MedicationStore = {
  medications: Array<Medication>;
  medicationNotes: MedicationNote[];
  isNotesLoading: boolean;
  noteActionStatus: NoteActionStatus;
  medicationStatusHistory: MedicationStatusHistory;
  isStatusHistoryLoading: boolean;
  updateSuccess: boolean;
};

export interface MedicationStatusHistoryItem {
  drug_usage_status_id: number;
  change_reason: string;
  national_drug_code: string;
  updated_at: string;
  updated_by: string;
  name: string;
  status: string;
}

export type FetchMedicationNotesSuccessAction = {
  type: MedicationStoreActionTypes.FETCH_MEDICATION_NOTES_SUCCESS;
  payload: MedicationNote[];
};

export type SetMedicationNotesLoadingAction = {
  type: MedicationStoreActionTypes.SET_MEDICATION_NOTES_LOADING;
  payload: boolean;
};

export type AddMedicationNoteSuccessAction = {
  type: MedicationStoreActionTypes.ADD_MEDICATION_NOTE_SUCCESS;
};

export type UpdateMedicationNoteSuccessAction = {
  type: MedicationStoreActionTypes.UPDATE_MEDICATION_NOTE_SUCCESS;
};

export type DeleteMedicationNoteSuccessAction = {
  type: MedicationStoreActionTypes.DELETE_MEDICATION_NOTE_SUCCESS;
};

export type SetMedicationNoteActionStatusAction = {
  type: MedicationStoreActionTypes.SET_MEDICATION_NOTE_ACTION_STATUS;
  payload: NoteActionStatus;
};

export type ClearMedicationNoteActionStatusAction = {
  type: MedicationStoreActionTypes.CLEAR_MEDICATION_NOTE_ACTION_STATUS;
};

export type MedicationStatusHistory = MedicationStatusHistoryItem[];

export type FetchMedicationStatusHistorySuccessAction = {
  type: MedicationStoreActionTypes.FETCH_MEDICATION_STATUS_HISTORY_SUCCESS;
  payload: MedicationStatusHistory;
};

export type SetMedicationStatusHistoryLoadingAction = {
  type: MedicationStoreActionTypes.SET_MEDICATION_STATUS_HISTORY_LOADING;
  payload: boolean;
};

export type SetUpdateMedicationStatusSuccessAction = {
  type: MedicationStoreActionTypes.SET_UPDATE_MEDICATION_STATUS_SUCCESS;
  payload: boolean;
};
export type ResetUpdateMedicationStatusSuccessAction = {
  type: MedicationStoreActionTypes.RESET_UPDATE_MEDICATION_STATUS_SUCCESS;
};

export type MedicationStoreAction =
  | GetMedicationSuccessAction
  | FetchMedicationNotesSuccessAction
  | SetMedicationNotesLoadingAction
  | AddMedicationNoteSuccessAction
  | UpdateMedicationNoteSuccessAction
  | DeleteMedicationNoteSuccessAction
  | SetMedicationNoteActionStatusAction
  | ClearMedicationNoteActionStatusAction
  | FetchMedicationStatusHistorySuccessAction
  | SetMedicationStatusHistoryLoadingAction
  | SetUpdateMedicationStatusSuccessAction
  | ResetUpdateMedicationStatusSuccessAction;

export interface Drug {
  nationalDrugCode: string;
  name: string;
}
